const IconDotUnfilled = () => (
    <span role="img" className="anticon">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 12 12"
            width="1em"
            height="1em"
            fill="currentColor"
        >
            <path
                fillRule="evenodd"
                d="M2 5.125c0-1.726 1.4-3.125 3.125-3.125h1.75c1.726 0 3.125 1.4 3.125 3.125v1.75c0 1.726-1.4 3.125-3.125 3.125h-1.75a3.125 3.125 0 0 1-3.125-3.125zm3.125-1.875c-1.036 0-1.875.84-1.875 1.875v1.75c0 1.036.84 1.875 1.875 1.875h1.75c1.036 0 1.875-.84 1.875-1.875v-1.75c0-1.036-.84-1.875-1.875-1.875z"
            />
        </svg>
    </span>
);

export default IconDotUnfilled;
